var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2391.38 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0e0e0;}.cls-2{fill:#d9d9d9;}.cls-3{fill:#b8b8b8;}.cls-4{opacity:0.43;}.cls-5{fill:url(#linear-gradient);}.cls-6{opacity:0.22;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:#699dd1;}.cls-12{fill:#396caa;}.cls-13{fill:#004e8c;}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:#6a75ba;}.cls-16{fill:#545d94;}.cls-17{fill:#eea886;}.cls-18{fill:#d9d3c8;}.cls-19{fill:#222538;}.cls-20{fill:#ffc955;}.cls-21{fill:#a77860;}.cls-22{fill:#c29941;}.cls-23{fill:#fff;}.cls-24{fill:url(#linear-gradient-7);}.cls-25{fill:url(#linear-gradient-8);}.cls-26{fill:url(#linear-gradient-9);}.cls-27{fill:#616587;}.cls-28{fill:#152b3d;}.cls-29{fill:#ffc05c;}.cls-30{fill:#254380;}.cls-31{fill:#353a3d;}.cls-32{fill:#e55353;}.cls-33{fill:#eea987;}.cls-34{fill:#2f4563;}.cls-35{fill:#202338;}.cls-36{fill:#2f6b8c;}.cls-37{fill:#877d78;}.cls-38{fill:#f5e1d9;}.cls-39{fill:#4b6f9e;}.cls-40{fill:#eddad3;}.cls-41{fill:#c9bab3;}.cls-42{fill:#1e2c40;}.cls-43{fill:url(#linear-gradient-10);}.cls-44{fill:url(#linear-gradient-11);}.cls-45{fill:url(#linear-gradient-12);}.cls-46{fill:url(#linear-gradient-13);}.cls-47{fill:url(#linear-gradient-14);}.cls-48{fill:#007bde;}.cls-49{fill:#1a598c;}.cls-50{fill:#2273b5;}.cls-51{fill:#3788cc;}.cls-52{fill:#81807e;}.cls-53{fill:#292c47;}.cls-54{fill:#cac7d1;}.cls-55{fill:#1d2033;}.cls-56{fill:#323657;}.cls-57{fill:#c78d71;}.cls-58{fill:#a09ea6;}.cls-59{fill:#eae6f2;}.cls-60{fill:#3a4066;}.cls-61{fill:#f2dfd8;}.cls-62{fill:#d6c5be;}.cls-63{fill:url(#linear-gradient-15);}.cls-64{fill:url(#linear-gradient-16);}.cls-65{fill:url(#linear-gradient-17);}.cls-66{fill:#ffa855;}.cls-67{fill:#ffa555;}.cls-68{fill:#858585;}.cls-69{fill:#e2d2ca;}.cls-70{fill:#1c1e30;}.cls-71{fill:#24263d;}.cls-72{fill:#282b45;}.cls-73{fill:#1f2136;}.cls-74{fill:#4f558a;}.cls-75{fill:#d6c5bf;}.cls-76{fill:#16202e;}.cls-77{fill:#007fe6;}.cls-78{fill:#6e6760;}.cls-79{fill:#918880;}.cls-80{fill:#706865;}.cls-81{fill:#eb4747;}.cls-82{fill:#d69779;}.cls-83{fill:#12131f;}.cls-84{fill:#9e633a;}.cls-85{fill:#97a43c;}.cls-86{fill:#82522f;}.cls-87{fill:#c67b47;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1057.39,
    y1: 690.39,
    x2: 2631.48,
    y2: 690.39,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc05c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1057.41,
    y1: 732.98,
    x2: 2632.35,
    y2: 732.98,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40d5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1820.95,
    y1: 1232.03,
    x2: 2382.35,
    y2: 1232.03,
    gradientTransform: "matrix(1, 0, 0, -1, -342.73, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfebfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1811.61,
    y1: 1304.11,
    x2: 2371.2,
    y2: 1304.11,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1915.68,
    y1: 1481.8,
    x2: 1599.26,
    y2: 580.32,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6cbcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f1fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2162.52,
    y1: 441.36,
    x2: 2639.68,
    y2: -248.58,
    gradientTransform: "matrix(1, 0, 0, -1, -342.73, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57c1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfebfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 423.47,
    y1: 1191.68,
    x2: 431.87,
    y2: 785.48,
    gradientTransform: "matrix(1, 0, 0, -1, -342.73, 2000)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 358.65,
    y1: 1190.34,
    x2: 367.05,
    y2: 784.14,
    gradientTransform: "matrix(1, 0, 0, -1, -342.73, 2000)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 877.64,
    y1: 1026.18,
    x2: 877.64,
    y2: 493.83,
    gradientTransform: "matrix(1, 0, 0, -1, -342.73, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#626e7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 876.07,
    y1: 833.15,
    x2: 876.07,
    y2: -306.57,
    gradientTransform: "matrix(1, 0, 0, -1, -342.73, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#44607d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1000.39,
    y1: 928.75,
    x2: 1018.9,
    y2: 928.75,
    gradientTransform: "matrix(1, 0, 0, -1, -342.73, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5e4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edfffe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1032.89,
    y1: 942.48,
    x2: 1051.4,
    y2: 942.48,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1067,
    y1: 935.3,
    x2: 1085.51,
    y2: 935.3,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1102.04,
    y1: 918.63,
    x2: 1120.55,
    y2: 918.63,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 936.53,
    y1: 540.48,
    x2: 936.53,
    y2: 630.15,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9f55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -6333.8,
    y1: 497.21,
    x2: -6286.09,
    y2: 497.21,
    gradientTransform: "translate(-5382.95 2000) rotate(180)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -6283.15,
    y1: 698.68,
    x2: -6237.63,
    y2: 698.68,
    gradientTransform: "translate(-5382.95 2000) rotate(180)",
    xlinkHref: "#linear-gradient-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1105.42,
    y: 1030.26,
    width: 5.53,
    height: 580.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1498.94,
    y: 1030.26,
    width: 5.53,
    height: 580.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1892.46,
    y: 1030.26,
    width: 5.54,
    height: 580.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 714.66,
    y: 958.7,
    width: 94.26,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 714.66,
    y: 986.68,
    width: 133.7,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1103.94,
    y: 958.7,
    width: 110.66,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1103.94,
    y: 986.68,
    width: 70.76,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1504.47,
    y: 958.7,
    width: 68.57,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1504.47,
    y: 986.68,
    width: 79.93,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1898,
    y: 958.7,
    width: 99.89,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1898,
    y: 986.68,
    width: 79.93,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1108.18,
    y: 1645.32,
    width: 62.61,
    height: 20.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1504.47,
    y: 1645.32,
    width: 62.61,
    height: 20.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1898,
    y: 1645.32,
    width: 62.61,
    height: 20.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2495.11,1438.39c-122.75,0-229.44-53.06-340.68-108.37-137.32-68.29-279.32-138.9-468.51-119.56-120.81,12.34-196.64,61.54-263.54,105-60.58,39.3-117.85,73.87-195.42,76.82-125.35,4.77-168.84-48.7-169.57-52V1306h0c.16.59,27.53,60.6,169.44,59.89,69.89-.35,121.47-33.82,181.19-72.57,69.41-45,148.07-96.07,275.22-109.07,196.78-20.11,342.25,52.23,482.94,122.19,147.21,73.2,287.68,141.85,465.3,82.29v28.21C2580.85,1433.88,2540.36,1438.39,2495.11,1438.39Z",
    transform: "translate(-342.73)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1758.35,1431.82c-90.6,0-162.46-60.93-232.81-120.58C1472.2,1266,1416.86,1219.78,1353,1197c-195-69.6-294.7,57.5-295.59,58.62V1217c1-1.32,18.85-24.42,70.32-46.48,46.86-20.08,125.49-36.1,233.94,1.62,68.7,23.9,125.77,72.28,180.95,119.07,111.94,94.9,208.62,176.87,376.52,48.48,127.16-97.24,247-189.9,365-223.76,115.36-33.11,235.63-8.87,348.21,103.71l-.83,35.11c-239.14-240.19-442.76-88-696.34,105.89C1868,1411.93,1810.1,1431.81,1758.35,1431.82Z",
    transform: "translate(-342.73)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1482.21 891.54 1478.22 886.85 1544.51 830.38 1584.77 830.38 1676.11 752.56 1733.24 801.23 1775.37 801.23 1796.67 819.37 1862.83 763.01 1896.41 763.01 2035.63 644.4 2039.62 649.09 1898.67 769.17 1865.09 769.17 1796.67 827.46 1773.11 807.39 1730.98 807.39 1676.11 760.65 1587.04 836.54 1546.78 836.54 1482.21 891.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1491.79 813.53 1468.88 813.53 1468.88 807.37 1489.24 807.37 1523.64 772.97 1548.65 797.99 1608.41 738.23 1626.79 756.61 1687.37 696.03 1723.67 732.33 1765.07 732.33 1828.95 668.45 1884.05 668.45 1924.78 627.72 1974.64 627.72 2024.11 578.24 2028.47 582.6 1977.19 633.88 1927.33 633.88 1886.6 674.61 1831.5 674.61 1767.62 738.49 1721.12 738.49 1687.37 704.74 1626.79 765.33 1608.41 746.95 1548.65 806.7 1523.64 781.68 1491.79 813.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2446.34,827.54a1.49,1.49,0,0,0-.11-.4c-58.92-205.48-206-381.11-409.14-471.49h0a740.25,740.25,0,0,0-391.54-58.73h-.38A736.73,736.73,0,0,0,1466,342.71l-.34.14c-210.12,82.63-379.6,260.49-442.76,495.23-106,394,127.33,799.15,521.16,905.14,202.24,54.41,407.43,19.38,573.6-80.89l31,43.09,146.19-105.28-35.29-49a739.37,739.37,0,0,0,186.8-723.59Zm-540.75,674.75c-261.11,93.58-548.65-42.23-642.23-303.34-91.83-256.25,37.26-538,288.91-636.81q7.15-2.8,14.43-5.42a502.26,502.26,0,0,1,642.24,303.34q5.67,15.84,10.24,31.8c72.13,252.25-63,520.63-313.59,610.43Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2591.81,785.67l-145.58,41.47-227.06,64.72q-4.56-16-10.24-31.8c-48.08-134.17-147.39-235.26-268-289.13l96.13-215.28h0L2047.21,333l51.66-115.7C2343.74,326.21,2520.92,538,2591.81,785.67Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2047.21,333l-10.12,22.66-96.15,215.28a501.14,501.14,0,0,0-266.46-40l-29-234-3-24.54A765.8,765.8,0,0,1,2047.21,333Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1674.48,531a504.25,504.25,0,0,0-107.78,25.76q-7.29,2.61-14.43,5.42L1466,342.71l-26.13-66.41A805.5,805.5,0,0,1,1636.61,226h.15l5.74,46.38,3,24.54Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "2274.59 2000 1983.49 2000 1781.17 1719.05 1972.87 1581.02 2274.59 2000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1578.6,175.07s-10.49-19.25-16.46-26.18-25.79-12.13-23.09-21,29.25-5,36.57,3.66S1605.26,143.31,1606,147s-7.75,23.68-12.54,26.95S1578.6,175.07,1578.6,175.07Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1534,191.38s-17.08-13.55-25.31-17.54-28.49-.89-29.53-10.08,24.86-16.21,35-11.17,31.86-1,34,2.06,2.29,24.81-.8,29.71S1534,191.38,1534,191.38Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1572,226.65s7.46-51,7.12-59.86c-.09-2.53,15.35-1.59,14.63,3.27-1.57,10.58,5.56,51.59,4.32,59.09S1571.33,231.38,1572,226.65Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1548.59,241.31s-14-49.53-17.24-57.77c-1.45-3.66,12.8-9.34,14.73-2.8,3,10.26,25.58,45.14,27.43,52.52S1549.88,245.9,1548.59,241.31Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1558.29,275.73s-15-50.62-17.32-56l23.68-14.63s11,32.34,12.51,40.42S1558.29,275.73,1558.29,275.73Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1977.37,142s-22.86,5.78-33.74,23.07-20.28,37.21-40.71,46.24-20.58,32.31-19,35.9,64.39,74.17,78.09,76.9,39.35.83,36.61-17.3S1969,249.64,1984.09,230,2003,192.14,2003,192.14Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1973.39,226.4a9,9,0,0,0-1.79-.33,13.12,13.12,0,0,0-5.35.64,12.16,12.16,0,0,0-2.09,1c-5.43,3.2-18.29,11.89-20,12.1-2,.24-.31-29.75-.31-29.75s6.85-12.11,7.71-20.08S1973.39,226.4,1973.39,226.4Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1812.56,257.74s-25.12-17.61-54.57-12.13-32.62,19.25-42.73,19.88-43.88-2.27-71.6,5.82-51.1,8.95-54.28,6.64,17.32-48.51,17.32-54.86l-34.36-9s-9.81,41-13.66,50.24c-4.12,9.88-12,28.48-.77,44.65s42.73,8.89,61.79,12.14,104.34,1.17,119.24.37c16.17-.86,65-3.17,65-3.17Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2018.87,166.45s1.6,24.82-3.91,32.26a35.6,35.6,0,0,1-4.71,5.47,10.89,10.89,0,0,0-3.13,4.55c-1.71,4.77-2.75,11.49-4.11,12.92s-5.76-2.41-7.31-2.42-16.67,13-20.28,10.36-25.67-25-23.82-40.38,8.62-38.25,33.45-38.11S2017,160.28,2018.87,166.45Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1943.83,284.88c-.47,1-9.6,15.59-19.6,24.05-4.15,3.52-8.45,6-12.35,6-1.19,0-2.35,0-3.47.05-11.48.31-20.3,2.07-35.79,2.84-16.1.8-55.15-1.44-56.31-1.44s-12.41,2-12.41,2c-4-4.91,6.64-60.34,8.66-60.63s15,4.62,27.43,2.6,17.32-3.18,35.8-24.83,37-27.14,44.75-25.41,23.29,0,23.29,0S1944.51,283.43,1943.83,284.88Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2008.43,184.22s4.63,12,7.08,13.64c0,0,8.93-9.44,3.2-32.75s-27.37-25.49-41.34-23.13c-17.38,3-34.88,61.77-34,67.5s20.38-30.4,37.44-27.49S1998,185.85,2008.43,184.22Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1971.6,226.07a13.41,13.41,0,0,0-5.33.74,11,11,0,0,0-2.11.94c-4-6.22-7.69-21-7.81-21.49C1959,212,1971.6,226.07,1971.6,226.07Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1924.23,308.93c-4.15,3.52-8.45,6-12.35,6-1.19,0-2.35,0-3.47.05l5.66-46Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2014.06,388.07,2003,398.15c-9.56-5.13-33.52-22.37-38.13-26.3-4.84-4.11-37.07-31.08-41.5-37.22s-10.12-69.66-9.54-72.57,28-4.34,31.14,2.38c0,0,1.43,36.22,2.17,42.28a31.48,31.48,0,0,0,7.18,16.65c5.75,7.06,18,23.45,29.88,36.7C1987,363.23,2010.41,384.92,2014.06,388.07Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1947.2,265.24s1.73-48.23-14-47.64c-19.84.76-22.81,25-20.12,51.4C1913.13,269,1942.77,269.29,1947.2,265.24Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2008.72,383.34a8.21,8.21,0,0,0,3.62,3.05c3.69,1.25,9.15-1.15,11.85,3.68s-10.31,16.92-13.81,17.66-9.09-4.71-13.46-15.43S2008.72,383.34,2008.72,383.34Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2023,388.56a166.4,166.4,0,0,1,13.34,11.54c5.89,5.69,11.87,13.15,10.36,14.56-2.06,1.93-6.07-4.48-12.28-9.75-5.72-4.85-5.4-3-5.4-3s-.06-.54,5.16,5.91c5.6,6.93,11.4,15.15,9.67,16.34-1.09.74-1.14.94-3.58-1.26,1.13,1.55.87,2.07.26,2.57-3.13,2.62-13-6.34-16.85-9.91,3,2.76,4.87,5.08,1.85,5.44-3.46.41-16.79-12.87-22-17.19C1997.86,399.12,2023,388.56,2023,388.56Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1823.85,260s-5.3,37.95-2.69,56.63c0,0,2.76,2.05,8.26.39,0,0,1.37-41.44,4.45-56.15C1833.87,260.82,1832.18,259.54,1823.85,260Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1482.37,
    width: 4.1,
    height: 288.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2123.21,
    y: 1495.11,
    width: 79.47,
    height: 5.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2123.21,
    y: 1505.6,
    width: 79.47,
    height: 23.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2085.87,
    y: 1536.9,
    width: 46.88,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2085.87,
    y: 1541.93,
    width: 46.88,
    height: 9.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2215.72,
    y: 1465.08,
    width: 3.5,
    height: 65.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "59.14 1069.88 135.54 1069.88 112.16 1021.37 35.75 1021.37 59.14 1069.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "23.39 1069.88 41.59 1069.88 18.21 1021.37 0 1021.37 23.39 1069.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 235.56,
    y: 854.23,
    width: 598.71,
    height: 52.47,
    rx: 23.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1151.89 1626.93 1455.9 1626.93 1360.09 1921.18 1369.05 1924.1 1468.88 1617.51 1145.05 1617.51 1046.16 1921.18 1055.12 1924.1 1151.89 1626.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1255.36 1921.18 1159.54 1626.93 1463.55 1626.93 1560.32 1924.1 1569.28 1921.18 1470.4 1617.51 1146.56 1617.51 1246.4 1924.1 1255.36 1921.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1123.6,
    y: 1710.17,
    width: 372.1,
    height: 9.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1085.27,
    y: 1812.48,
    width: 445.19,
    height: 9.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1647,955.36s7.58-13.26-4.44-48.81c-11.63-34.37-51.86-31.26-64.65-9.23s-8.47,35.7,10.36,60.57S1639.14,966.73,1647,955.36Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1553.5,1566.9s-2,14.59-2.24,16.79-22.15-1.3-22.15-1.3l-1.78-17.37S1550.76,1564.84,1553.5,1566.9Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1551.49,1581.83s6.94,8.8,13.65,12.63,17.26,5.35,21.23,9.32c2.86,2.87,10.43,15.2-17.44,15s-41.32,1.74-44.3-3,4.32-34.9,4.32-34.9S1535.77,1582.77,1551.49,1581.83Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1705.14,1566.9s-2,14.59-2.24,16.79-22.15-1.3-22.15-1.3L1679,1565S1702.4,1564.84,1705.14,1566.9Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1703.13,1581.83s6.94,8.8,13.65,12.63,31.41,7,35.38,11c2.86,2.87,7.63,14.4-31.59,13.32-27.87-.77-41.31,1.74-44.3-3s4.32-34.9,4.32-34.9A115.56,115.56,0,0,0,1703.13,1581.83Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1560.87,1203.42s-11.23,34.9-9.75,65-5.81,63-8.78,94.39c-3.32,35-16.91,117.93-17.4,136.67s2.11,78.55,2.11,78.55l27.19.65S1577.08,1433.74,1583,1419s35.25-120.22,36.24-132.06S1560.87,1203.42,1560.87,1203.42Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1673.64,1199.79s16.51,92.26,18.48,110.67,3.29,89.07,4.27,100.57,6.57,150.53,11.83,167.62H1677.9s-31.14-101.06-31.14-148.88-20.62-104-33.93-135.51-43.78-32.3-52-90.84C1560.87,1203.42,1662.56,1181.22,1673.64,1199.79Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1636,964.75s-3.42,10,0,17.06-43.71,2.84-43.71,2.84,2.13-14.69-4-26.76S1636,964.75,1636,964.75Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1558.68,1211s17,17.41,116.47-2.72l-1.51-8.52L1560.5,1204Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1643.09,984.11s17.41,1.78,22.38,2.73,38.45-6,45.32-6.7,36.15-20.78,37.09-23.14,17.82-45.08,18.77-54.32,16.43-4.47,15.1,1.9c-2.48,11.9-5.67,40.8-7.42,49.18-1.89,9-6.95,29.53-9.79,32s-29.21,22.58-55,31.1a220.18,220.18,0,0,0-45.25,21.08H1537.06s-49.49-70.73-50.55-81.39,34.56-81.49,41.67-90.37,17.38,2.9,17.38,2.9-21.29,62.47-24.13,71.35,24.76,47.9,32.34,48,27-2.36,35.68-2.72,17.76-4.14,17.76-4.14Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1697.92,1031.36s-15.58,10.35-17,28.11-7.1,45.83-10,55.42,2.49,79.21,3.2,84.19-98.44,16.79-113.67,5c0,0-4.26-65-6-83.48s-10.3-63.23-13.14-69.27S1504,997,1502.59,990.59c0,0,17.83-28.42,30.61-28.77,0,0,20.31,23.8,26.94,24.86s47.21-6.37,47.21-6.43,4.43,6,28-1.07c0,0,28.05,3.16,32.61,3.74,5.52.71,43.93-4.82,43.93-4.82s15.4,26,12.71,39.16Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1765.76,908.23s3.48-16.46-.71-21.19c-2.38-2.69-8.12-9.81-8.64-10.86s-6.67-4.58-6.67-6.28,6-3.8,11.25,1.05,8.51,5.89,10.6,5.36,5.1-17.93,5.37-22.24,1.92-15.71,4.62-14.92,2.57,5.76,2.57,5.76,3.14-8.64,5.24-6.94,1.83,5.89,1.83,5.89,3.92-4.84,5-1.31a12.23,12.23,0,0,1,0,6.68s4.06-2.23,4.32,3.27-1.18,21.59-4.06,27.35-13.65,20.81-14.94,26.69S1765.76,908.23,1765.76,908.23Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1542.09,879.32s11.83-19.9,15.86-21.67,9.71-2.78,14.68-6.34,11.55-6.51,11.19-7.69-6.21-.71-12.49,2-9,1.41-9.62,0,3.35-11.46,5.24-13.83,15.39-15.94,13.14-17.95-11,5.44-12.43,7c0,0,7-14.68,4.26-15.39s-7.81,4.5-7.81,4.5.59-12.55-12.91,7.81c0,0,2.84-6.75-1.3-4.5s-8.17,14.92-9.47,21.32-7.22,26.76-12.25,31.67S1542.09,879.32,1542.09,879.32Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1588.23,957.89s6.23.55,19.49-4,14.26-27.77,17.12-25c5.86,5.6,11.38,1.73,13.59-1.58,0,0-6.47-8.53-3.47-12.63a31.76,31.76,0,0,1,7.88-7.1s-9.33-45-51.77-24.48C1541.33,907.05,1588.23,957.89,1588.23,957.89Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1636,981.81l-1.5-6.5s-27.09-.55-41.87,1.59l-1.56,7.77S1610,993.25,1636,981.81Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1629.28,923.15c-2.47-4.09-11.57-6.84-12.64,4.74-.82,9,16.27,18.79,16.42,10.42S1630.91,925.87,1629.28,923.15Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1766.4,904.49s9.78.24,14.52,4.53a9.67,9.67,0,0,1-.79,4.86s-8.48-4-15-4.69C1765.16,909.19,1765.26,905.63,1766.4,904.49Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1777.93,906.93a4.21,4.21,0,1,1-5.52-2.24h0A4.21,4.21,0,0,1,1777.93,906.93Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2550.17,1134.93s-8.67,1.16-8.6-2.52.66-8.46.66-8.46Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2598.94,1095.11l-28.48,22c3.63-.69,9.71-1.56,9.84.34.2,2.71-10.82,6-14.32,8.44-3.2,2.26-6.56,6.29-7.45,6.48l-6.23,5.33-10.07-13.7s16.62-18.81,20.63-22.82c6.51-6.53,32.86-10.36,34.31-9.41C2599.77,1093.43,2598.94,1095.11,2598.94,1095.11Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2563.79,1138.67l-23-19.46L2462,1198.82c-12.33,8.48,24.05,37.71,34.33,44.08,26.42,16.38,57.57,54.28,89.88,31.17,35-25.06-16-42.89-33-42.45-14.73.38-46.83-28.6-46.83-28.6Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2522.2,1853.1s-13.09,13.74-26.38,16.62-22.58,6.55-22.68,14.44,38.24,13.09,53.45,5.13c22.7-11.86,25-8.29,27.52-14.22s-3-21.79-2.86-23.68C2551.45,1849.06,2522.2,1853.1,2522.2,1853.1Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2523.67,1846.52s-1.73,6.44-1.47,6.58,30,3.46,29.05-1.71c-.73-4.19-1.77-8.74-1.77-8.74Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2670.07,1856.68s-9.63,13.39-22.51,16.48c-12.7,3-20.93,8.84-21.55,16.5s29.94,17.71,51.41,4.24c14.11-8.85,19.38-8.34,22.22-14s-1.49-21.38-1.21-23.21C2698.79,1854.48,2670.07,1856.68,2670.07,1856.68Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2670.46,1850.06s-.63,6.47-.39,6.62,28.53,5.15,28.36,0a39.67,39.67,0,0,0-1.79-9.09Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M2553.62,1459.79s-13.75,99.87-19.37,133.63c-6.56,39.48-8.79,72.09-10.62,92.52-2.3,25.7-5.36,157.21-7,164.73s40,3.6,40,3.6,21.82-171.44,28.68-198.81c6.39-25.48,25-135.55,30.81-128.6s23.67,131.65,28,151.75,15.88,178.31,15.88,178.31,39.3,6.3,47.21,0c0,0-6.2-141.08-9-178.76-1-14.36,9.08-171.91-15.2-235.45C2670.3,1409.14,2553.62,1459.79,2553.62,1459.79Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2594,1220.27s-36.38,7.53-40.7,11.35c-4.69,4.07-13,43.92-13.45,55s4.39,57.46,9.08,74.73,4.74,92,1.78,115.89c0,0,70.08,14.34,142.1,5,0,0-9.82-72.66-6.93-96.32,3.69-30.31,12.58-100.14,12.58-100.14s.06-39.31-5.52-45.6c-11.94-13.48-57.87-19.89-57.87-19.89Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2648.59,1293.17c1.7,36,13.16,44.72,24.44,41.92a24.69,24.69,0,0,0,10.06-5.53c4.8-4.18,8.56-10,9.91-15.42,4.93-20.05,5-75.31-20.32-82.42C2672.68,1231.72,2645.26,1222.84,2648.59,1293.17Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M2539.78,1309.51s20.3-3.37,21.54,26.07,14,84.13,34.74,105.92l-81.68,3.1c-20.76-21.8-31-74-32.51-103.41-1.42-27-21.54-26.07-21.54-26.07Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2587.43,1242.09a11.24,11.24,0,0,0,1.5.87,20.69,20.69,0,0,0,7.14,2,25.08,25.08,0,0,0,3.24.13,11.25,11.25,0,0,0,2-.12c19.26-1.88,38.38-23.91,38.38-23.91-38.67-5.86-55.25,1.34-55.25,1.34S2578.25,1235.9,2587.43,1242.09Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2595.7,1108.83s-45.75-9.18-34,47.84,22.81,61.26,50,48.76,23.84-49.14,24.79-67.17S2610.23,1109.11,2595.7,1108.83Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2588.23,1228.15s9,5.95,43.16-9.09a120,120,0,0,1,1.86-42.53c5.07-21.42-41.95,26.41-41.95,26.41.55.38.65,2.57.34,5.62-.09.83-.2,1.71-.35,2.63-.24,1.57-.57,3.27-1,5-.12.47-.23.94-.36,1.41C2588,1224.9,2588.23,1221.77,2588.23,1228.15Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2635,1167.7s-2.3-15.36-8.9-15.77-8.5,9-8.5,9l-5.18.54s2.14-16.28-4.5-18.88-42.55,6.26-48,1.74-2.73-34.53,6.72-39.15,34.66-17.2,54.31-4.58c0,0,15-2.08,17.55,10S2638.85,1158.56,2635,1167.7Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2617.82,1146.55c1.11-5.36,12-6.42,12.15,1.78s-6.8,22-10.75,20.21S2616.28,1154,2617.82,1146.55Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2631.38,1212.59s-17.86,10.77-35.52,13.19l9.4,15,29.77-20.5Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2590,1217.6s1.88,6.17,5.91,8.18l-8.82,12.31.32-16.32Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2595.86,1225.78l-7,9.74s4.42,5.6,14,1.36Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2588.93,1243a20.69,20.69,0,0,0,7.14,2,25.08,25.08,0,0,0,3.24.13l-1-9.08h-6.46A29.27,29.27,0,0,0,2588.93,1243Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2590.1,1217c20.25,1.07,33.21-19.93,33.6-20.55-12.71,13.89-32.41,14.72-32.41,14.72C2591.05,1212.76,2590.52,1215.28,2590.1,1217Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M2539.78,1309.51s-24.31,2.26-19.17,36.19l-72.16,3.9s-9.95-23.11,11.88-34.48Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2455.32,
    y: 1332.96,
    width: 56.43,
    height: 2.94,
    transform: "translate(-410.84 135.37) rotate(-3.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2460.14,
    y: 1319.98,
    width: 56.43,
    height: 2.94,
    transform: "translate(-410.14 135.61) rotate(-3.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2490.39,
    y: 1348.85,
    width: 56.43,
    height: 2.94,
    transform: "translate(-411.64 137.28) rotate(-3.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2497.44,
    y: 1368.61,
    width: 56.43,
    height: 2.94,
    transform: "translate(-412.7 137.68) rotate(-3.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2504.52,
    y: 1388.3,
    width: 56.43,
    height: 2.94,
    transform: "translate(-413.74 138.09) rotate(-3.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2511.57,
    y: 1408.07,
    width: 56.43,
    height: 2.94,
    transform: "translate(-414.8 138.5) rotate(-3.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2518.65,
    y: 1427.76,
    width: 56.43,
    height: 2.94,
    transform: "translate(-415.84 138.91) rotate(-3.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2602.33,1372.92s-3.14,1.48-5.85.74c-4.69-1.28-8.69-7.79-14.82-4.45s-1,25.79,2.13,29.08,12.67,1.37,24.6-7.19S2602.33,1372.92,2602.33,1372.92Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2583.89,1368.39a199.86,199.86,0,0,0-21.79,3c-10,2-22.19,5.87-21.72,8.4.72,3.84,10.33-.48,20.4-1.79,9.27-1.2,7.64.61,7.64.61s.44-.54-9.41,2.76c-10.59,3.54-21.82,7.79-21.47,9.87.43,2.58.7,2.86,4.75,2.21-2.25.88-2.33,1.63-2.05,2.61,1.43,5.09,17.8,2.33,24.3,1.24-5,.87-8.55,2-5.66,4.6,3.3,2.91,26.27-2,34.67-3C2602.71,1397.86,2583.89,1368.39,2583.89,1368.39Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2664.61,1232.43c-7.43,2.44-11.4,12.94-6.87,34.74,5,24.11,10.59,35.83,13.82,41.51s20.64,34.75,17.45,39.36-45.26,15.55-48.13,16.36c-5.7,1.62-43.89,9.24-43.89,9.24l9.35,32.7s116.25-19.83,121.91-25.49,8.61-13.33,2.36-33.09c-6.37-20.09-17.8-67.13-19.83-70.8S2698.11,1221.42,2664.61,1232.43Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M2658.77,1271.93s2.61,36.93,14.26,63.16a24.69,24.69,0,0,0,10.06-5.53s-13.45-24.28-14.65-27S2660.13,1278.35,2658.77,1271.93Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 237.28,
    y: 940.67,
    width: 592.11,
    height: 422.13,
    rx: 33.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 657.66,
    y: 1019.8,
    width: 18.51,
    height: 102.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 690.16,
    y: 992.36,
    width: 18.51,
    height: 130.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 724.27,
    y: 1006.71,
    width: 18.51,
    height: 115.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 759.31,
    y: 1040.04,
    width: 18.51,
    height: 82.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 657.66,
    y: 1057.44,
    width: 18.51,
    height: 65.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 690.16,
    y: 1040.04,
    width: 18.51,
    height: 82.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 724.27,
    y: 1049.14,
    width: 18.51,
    height: 73.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 759.31,
    y: 1071.25,
    width: 18.51,
    height: 51.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 662.74,
    y: 1157.93,
    width: 110,
    height: 29.33,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 662.74,
    y: 1212.85,
    width: 110,
    height: 29.33,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 662.74,
    y: 1267.77,
    width: 110,
    height: 29.33,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M952.29,1092.5a163.43,163.43,0,1,0-307.77,110.07h0c1.23,3.46,2.58,6.86,4,10.19A163.44,163.44,0,0,0,952.29,1092.5ZM839.67,1262.91a122.39,122.39,0,0,1-153.62-66.48c-1.08-2.49-2.08-5-3-7.64a122.53,122.53,0,1,1,156.64,74.12Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M681.44,1111l-39.05-12.19A163.69,163.69,0,0,1,793.52,984.13l1.22,40.89a122.72,122.72,0,0,0-113.3,86Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M686.05,1196.43l-37.51,16.33c-1.44-3.33-2.79-6.73-4-10.19a162.76,162.76,0,0,1-2.13-103.75l39,12.18a121.9,121.9,0,0,0,1.59,77.78Q684.43,1192.7,686.05,1196.43Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M673.88,1253.44a162.45,162.45,0,0,1-25.34-40.68l37.51-16.33a121.72,121.72,0,0,0,19,30.51Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1119,1840.9s-6,11.17-9.9,15.61-18.9,12.36-19,25.53c-.09,14.29,25.26,10.32,35.17,9.8s10.67-8.15,14.84-16.24,8.38-6.72,9.17-13.24-4-21.46-4-21.46Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1144.94,1836.59s1.16,6.09.94,6.24-28.1,5.12-27.94.06c.12-4,2.57-8.7,2.57-8.7Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1400.18,1311.41s29.24-6.15,31.43-4.88,2.32,2.92-.4,3.61-28.13,6.79-28.13,6.79,35.46-1.29,37.49-.67c1.19.36,1.64,3.53.21,4s-36.61,3.88-36.61,3.88,33.1-1.14,34.62-.08a2.46,2.46,0,0,1,.11,3.48,2.42,2.42,0,0,1-1.53.76c-2.46.26-33.23,3.13-33.23,3.13s24.06.74,24.8,2.46c.45,1,1,3.76-5.23,3.36s-21,.28-21,.28Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1270.05,1838.79s12.21,13.63,24.62,16.49,21.07,6.5,21.17,14.33-35.69,13-49.89,5.09c-21.18-11.77-23.33-8.22-25.68-14.11s2.82-21.62,2.67-23.5C1242.75,1834.78,1270.05,1838.79,1270.05,1838.79Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1268.67,1832.26s1.62,6.39,1.38,6.53-28,3.43-27.11-1.7c.68-4.15,1.65-8.67,1.65-8.67Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1243.48,1449.76s10.08,97.86,15.32,131.36c6.13,39.17,8.2,71.53,9.91,91.81,2.15,25.5,2.57,150.93,4.07,158.38s-33.38,2.06-33.38,2.06-17.16-163.89-23.56-191c-6-25.29-28.08-134.16-33.52-127.25s-12.18,127-16.21,147-16.28,176.07-16.28,176.07-27.76,5.53-35.14-.72c0,0-3.36-134.55-.8-171.94,1-14.25-16.69-170.84,6-233.89C1131.84,1398.26,1243.48,1449.76,1243.48,1449.76Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1070.78,1463.66s17,5.16,24.1,3.85,3.52-88.61,3.8-106.78c.22-14.73,8.28-53.64,8.28-53.64v.07h0v.07c.8,2.91,11.68,43.28,12.06,62.68.4,20.13-2.62,97.14-2.62,97.14l30,2.92,86.19,2.11,18-2.12s-2.15-32.93-2.95-48.57c-.49-9.94-2.42-27.74-1.93-45.08,0,0-.31-18.27,1.5-26.14.2-34.74,2.3-69.14,2.3-69.14q1.76-23.62,2.44-44.22c-3.8-2-8.36-4.36-12-6.1-11.32-5.38-27.08-12.64-37.19-17.28-5.93-2.72-11.72-4.71-11.72-4.71s-40.43-3.87-43.71-3.67c-1,.07-6.09,1.83-12.72,4.36-14.33,5.43-42,16.51-46.37,19.67-6.46,4.62-20.1,114.42-20.72,122.11C1066.39,1365.08,1070.78,1463.66,1070.78,1463.66Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1248,1456.24s-59.16,5-111,0v17s77.82,11.24,113.57-3.24Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1197.54,1211.23s9.62,22.61,16.84,73.14c2.78,19.41,7.92,52.08,11.65,85.43h0c3,26.28,9.68,53.26,11.81,73.38,2.22,20.85,8.89,82.26,8.89,82.26l16.18-10.21c2.31-2.13,5.55-4.91,4.61-7.91-4.45-14.37-13-61.86-18-103.26V1404q-.36-3-.7-5.93v-.32c-1-8.27-1.74-16.21-2.3-23.47a74.44,74.44,0,0,1,.72-16.34c2.26-37.16,3.38-76.33,3.38-76.33,1.18-16,1.86-31,2.32-45a87.65,87.65,0,0,0-12.47-7S1204.3,1213.19,1197.54,1211.23Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1194.5,1223s1.08,15.48-12,15.84-23.47-12.21-23.47-12.21l21.72,5.6L1194,1221Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1367.36,1323.9s9.53-2.65,10.8-8.35c1.09-4.85,5.81-10.5,7.26-12.24,1.94-2.33,5.46-11.64,8.17-9.28s-5.11,15.6-6.23,18.68,12.08-2.33,15.13-1.38,9.22,23.74-.2,26.39-20.81-.9-22.39-.09a60.43,60.43,0,0,1-6.79,2.21Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1176.83,1104.51s30,5.06,24.93,52.06-31.59,42.85-33.36,42.78-26.65.57-28-56.89C1140.44,1142.46,1140.05,1100,1176.83,1104.51Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1190,1185.73s0,19.36.79,23.55c.85,4.5-24.11,17.52-40.22,2.35,0,0,3.26-21.14,2.25-28.6S1190,1185.73,1190,1185.73Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1201.88,1145.62s3.33-3.48,4.5.09-4.23,18.68-4.92,20.14c0,0-.62,1.37-1.4.6S1201.88,1145.62,1201.88,1145.62Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1140.78,1142s-3.18-3.62-4.5-.1,3.49,19.34,4.09,20.32c0,0,1,1.62,1.84.89S1140.78,1142,1140.78,1142Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1204.29,1139.29c-1,6.43-2,11.21-2,11.21l-4.37,5.71s.26-12.62-.41-14.6c-.25-.75-.55-2.08-.86-3.52-.5-2.38-1-5.06-1.36-6-.57-1.43-25.73-8.78-48.14,1.54,0,0,.19,1.94.17,4.11,0,2.52-.28,5.34-1.44,5.76-2.15.79-1.25,14.77-1.25,14.77l-3.49-4s-1-7.3-2-15.69v-.06c-.22-2-.45-4-.67-6-.5-8.44.34-23.77,11.33-32.77,7.41-3.18,19.26-5.88,39,.17,0,0,4.92,1.4,6.19,2.62C1207.25,1116.1,1204.29,1139.29,1204.29,1139.29Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1154.87,1193.07s4.79,6.65,15.92,6.4,16-6.06,16-6.06-5.27,11-16,10.91S1154.87,1193.07,1154.87,1193.07Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1191.94,1224l-11.2,8.28s9.41-19.94,9.6-27.93Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "847.61 1204.32 855.23 1211.4 863.24 1235.3 849.21 1223.97 847.61 1204.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1380,1346s-66.09,17.41-82.25,13.43c-7.47-1.84-17.31-12.15-26.66-24.27-3.08-4-6.1-8.18-9-12.33h0c-11.47-16.56-20.46-32.43-20.46-32.43s-33.9-39.73-6.69-57.45c0,0,11.46-1.15,18,3.66,6,4.44,20.67,32.41,23,37.6s28.14,53.33,29.86,54.41,23.82-2.87,35.49-3.84a186.54,186.54,0,0,0,34.84-6.42Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1188.9,1211.45a132.6,132.6,0,0,1-8.16,20.8s-11.75-10.29-15.45-14S1188.9,1211.45,1188.9,1211.45Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1168.44,1220.74l12.3,11.51s-14.54-1-17.25-3.38Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1152.13,1199.53s9.84,16,16.31,21.21l-10.91,18.12L1140,1207.08Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1099.91,1361.56c-1.25,16.86,5.88,110.15-1.23,111.46s-33.28-4.44-33.28-4.44-3.28-100.61-2.23-111.15c.77-7.68,13-122.81,19.44-127.44,3.73-2.67,31.34-12.46,44.89-17.8,2.48-1,10.32-4.27,12.54-5.11,2.87,3.2,27.91,62,30.29,107.77.72,14-2.54,43.41-5,67.47-2.65,25.67-5.59,45.71-7.75,67.17-4.24,42.3-7.21,76-7.21,76l-42.09-18.74c-6.81-3.41-16.25-17.4-13.68-24.57,9.73-27.26,22-73.82,22-97.74,0,0-4.69-58.57-8.41-71.44C1108.15,1313,1101.51,1340.12,1099.91,1361.56Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 835.27,
    y: 1457.29,
    width: 27.88,
    height: 20.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "772.77 1566.76 681.03 1566.76 702.55 1505.67 794.29 1505.67 772.77 1566.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "772.77 1566.76 681.03 1566.76 702.55 1505.67 794.29 1505.67 772.77 1566.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "702.55 1627.85 794.29 1627.85 772.77 1566.76 681.03 1566.76 702.55 1627.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "772.77 1688.94 681.03 1688.94 702.55 1627.85 794.29 1627.85 772.77 1688.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "702.55 1750.04 794.29 1750.04 772.77 1688.94 681.03 1688.94 702.55 1750.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 707.93,
    y: 1515.87,
    width: 52.32,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 704.82,
    y: 1524.07,
    width: 52.32,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 701.43,
    y: 1532.27,
    width: 42.33,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 707.93,
    y: 1637.63,
    width: 52.32,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 704.82,
    y: 1645.83,
    width: 26.16,
    height: 2.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1093.44,1474.18s.49,1.56,1.36,4.18c1.48,4.52,6.28,9.67,3.33,15.84s-25.16,2.28-28.54-.59-2-12.31,5.77-24.42S1093.44,1474.18,1093.44,1474.18Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1098.82,1492a200,200,0,0,1-1.85,21.45c-1.44,9.9-4.6,22-7.1,21.65-3.79-.5-.06-10.11.7-20,.7-9.13-1-7.44-1-7.44s.51-.46-2.21,9.34c-2.92,10.54-6.49,21.73-8.54,21.5-2.54-.29-2.84-.54-2.41-4.54-.74,2.25-1.47,2.36-2.45,2.14-5-1.14-3.19-17.28-2.45-23.69-.6,4.92-1.57,8.47-4.21,5.77-3-3.08.65-25.78,1.17-34C1069.05,1475.09,1098.82,1492,1098.82,1492Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1101,1408.72l-.43,74.14s-14.8-.66-35.19-8.19L1064,1370.12Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M982.48,1374.66l-51.48,116-1.39,3.11a13.84,13.84,0,0,1-5.72-.59l1.14-2.56,51-114.85-74.29-79.89-11.16-2.43,1.17-5.35,12.83,2.8Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M903.2,1513.05h47.65a19,19,0,0,0-.52-2.9c-1.44-5.66-6.66-17.63-25.2-17.63s-21.56,12-21.94,17.63A17.55,17.55,0,0,0,903.2,1513.05Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M854.67,1270.18l3.22,9.12,19.51,55.28a34.15,34.15,0,0,0-21.85-64.71Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M932.2,1490.64v2.54a12.73,12.73,0,0,1-2.59.56,13.84,13.84,0,0,1-5.72-.59l-.33-.12v-2.45H931Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M903.2,1513.05h47.65a19,19,0,0,0-.52-2.9H903.19A17.55,17.55,0,0,0,903.2,1513.05Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M854.67,1270.18l3.22,9.12c11.39,9,29.06,24.49,37.63,40.3a34.14,34.14,0,0,0-40.85-49.42Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M693.9,1368s8.31-10.5,9.62-12.06,6.46-3,12.5-4.17,14.51.28,15.2,1.12a5.66,5.66,0,0,1,2,4.25,12.44,12.44,0,0,1-1,5.65,7.37,7.37,0,0,1,.14,6.6,6.49,6.49,0,0,1-.89,6.6s1.53,3.23-.49,5.49c0,0-5.16,1.49-7,2.65s-12.7,3.45-23.4,3.89C700.67,1388.05,690.6,1384.7,693.9,1368Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "111.64 1692.01 64.34 1889.23 53.92 1889.23 94.03 1691.58 111.64 1692.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "163.24 1692.01 115.94 1889.23 105.52 1889.23 145.63 1691.58 163.24 1692.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "246.7 1692.01 294.01 1889.23 304.42 1889.23 264.31 1691.58 246.7 1692.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M634.2,1693.93H430.38s-14.19-.33-23.7-42.39c-10.69-47.3-32.3-205.32-32.3-205.32s5.73-14.7,95.33-12.82l160.45,208.17S635.63,1674.39,634.2,1693.93Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M640.48,1496.72s10.38-4.51,18.17-2.69,26,8.62,35,9.76,17.6,6.36,17.43,9.36-69.57,5.44-69.9-1.38S640.48,1496.72,640.48,1496.72Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M693.9,1368s-13.56,8.92-13.85,11.65c-.49,4.52,2.3,18.56,2.64,18.36s20.44-10.12,20.44-10.12Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M693.62,1855.65S711.08,1866,719,1869.89s38.68,5,41.71,7.94,1.9,12.1-3.2,13-42.51,4.21-55,1.27-35.82,1.9-41,.13-1.76-29.62.25-35.87S693.62,1855.65,693.62,1855.65Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M693.35,1843.86l.27,11.79s-23.4,4.31-31.84.73l.59-13Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M734.51,1855.65S752,1866,759.89,1869.89s38.67,5,41.71,7.94,1.89,12.1-3.21,13-42.51,4.21-55,1.27-35.82,1.9-41,.13-1.76-29.62.26-35.87S734.51,1855.65,734.51,1855.65Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M734.24,1843.86l.27,11.79s-23.39,4.31-31.83.73l.59-13Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "254.09 1569.44 227.52 1564.8 245.24 1520.19 254.09 1569.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M517.22,1578.58s133.52,28.35,154.36,37.21,33.33,12.5,34.9,16.92S740.6,1848.9,740.6,1848.9H696.32s-34.38-159.9-38.55-169.82-169.3-10.42-181.28-22.4-22.4-44.8-9.38-74.23S517.22,1578.58,517.22,1578.58Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M584.84,1563.69S738,1606.77,750.5,1626.46c12.76,20.06-51,222.44-51,222.44H655.69s42.19-189.62,37-198-236-.26-193-68.5S584.84,1563.69,584.84,1563.69Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M568.92,1350.89c5.76-3,25,3.57,30.66,12.41,13.19,20.55,38.13,45.93,38.13,45.93l55.61-46.74,11.14,27.86-66,55.63a14.32,14.32,0,0,1-19.2-.67c-17.34-16.84-53-52.23-55.78-61.08C559.84,1372.51,557.91,1356.62,568.92,1350.89Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M550.1,1231.86s26.57,4.43,26.83,49.49-16.83,49.31-42.71,42.71c-15.59-4-30.22-26-24.49-64.85S550.1,1231.86,550.1,1231.86Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M553.58,1339.43s36.62,13.3,42.09,21.63,1.93,83.34-1.19,110.17-11.72,84.65-9.64,92.46l-85.17,18.76s-27.35-99.5-28.13-115.39-20.84-89.86-11.2-95.85,51.57-29.44,51.57-29.44Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "156.94 1582.44 152.77 1567.08 242.3 1549.64 242.11 1563.69 156.94 1582.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "201.48 1556.79 222.7 1552.36 222.7 1569.16 201.48 1574.11 201.48 1556.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M534.69,1513.06c-.23,4.39-.52,8.84-.74,13.35l-.06.06c-3,49.43-7.54,101.15-7.54,101.15-6.22,5.19-85.1-13.13-85.1-13.13s9.7-13.18,19.06-49.72,2.06-71.52-7.71-130.88-1.65-59-1.65-59l61-33.11c4,15.18,20.15,70.26,24,101.83C537.26,1455.12,536.4,1482.69,534.69,1513.06Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M554.17,1339.54s17.75,45.85,25.29,92.62c7.68,47.68,7.3,134,15.63,136.12s5.75.7,5.75.7-1.56-52.16-2.32-69.45c-1.7-38.59,5.5-125.58,2.17-134.37S573.45,1343,554.17,1339.54Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M552.73,1332.34a22.29,22.29,0,0,0,.85,7.08s-4.68,18.26-41.67,2.34c0,0,7.31-27.23,0-50.06l41.67,25.86s-.51,4.11-.74,8.9C552.73,1328.4,552.67,1330.46,552.73,1332.34Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M513.42,1334.52s14.54,7,29.21,8.39l-7.15,15.21-23.57-16.35Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M542.63,1342.91s10.23-3.39,10.16-8.39l1.38,5-4.17,16Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M573.75,1257.93s7.44-16,2-27.65-19.44-6.84-25.87-5.46-18.58-12.85-40.11,4.52-15.11,35.6-5.56,57.3S515,1310,515,1310s.07-22,2.67-25.94c3.05-4.59,14.23-7,14.23-7s-8.51-11.63-.17-16S557.29,1264.81,573.75,1257.93Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M520.93,1272.58c-1.13-3.33-6.74-7.11-9.55-.87s4.52,17.19,8.51,17.19S523.54,1280.22,520.93,1272.58Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M542.63,1342.91l5.34,9.18s-2.47,2.84-10.41,1.6Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M546.83,1352.9s21.86,64.32,22,110-3.43,72.93-3.43,72.93l-4.81,9-7-8.22s5-132.61-14.48-182.71C539.1,1353.89,546,1350.59,546.83,1352.9Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M457.72,1371.21c16-6.53,32.57,15.62,41.43,37.76s25.78,62.43,25.78,62.43l118.28,19.16,1.67,22.49h-138s-52.57-94.18-56.22-105.9S446.23,1375.89,457.72,1371.21Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 260.23,
    y: 1513.05,
    width: 390,
    height: 13.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 488.76,
    y: 1277.92,
    width: 9.39,
    height: 208.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M854.52,1513.05H924.8v-4.26H854.52c-3.66,0-6.3-.87-7.83-2.59a6.89,6.89,0,0,1-1.56-4.89v-91.07h-4.26V1501a11.19,11.19,0,0,0,2.58,8C845.84,1511.68,849.56,1513.05,854.52,1513.05Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M832.94,1513.05h-79.1v-.61a6.84,6.84,0,0,1,6.84-6.84h72.26v7.46Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 609.68,
    y: 1526.49,
    width: 11.08,
    height: 364.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 289.71,
    y: 1526.49,
    width: 11.08,
    height: 364.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M534.69,1513.06c-.23,4.39-.52,8.84-.74,13.35l-.06.06s-15.37,2-28.26-3.82-21.92-50.41-22.54-52.75c1.31,2.57,22,43.16,27.05,43.16Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M552.84,1326.46c-.11,1.94-.17,4-.11,5.88-29.4.46-29.86-16.32-29.86-16.32C527.44,1328.17,552.84,1326.46,552.84,1326.46Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 706.36,
    y: 1349.16,
    width: 44.67,
    height: 3.78,
    transform: "translate(-1076.65 885.12) rotate(-43.99)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "400.68 1334.29 406.73 1331.09 403.31 1337.01 400.68 1334.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M729.63,1353.15s-15.24,3.29-15.18,6,1.61,3.63,1.61,3.63l-5.85,4.47s-2.45,5.28,3.38,6.42c0,0-2.75,4.7,3,5.06,0,0-.6,3.93,2,4.61s12.37-1.87,12.37-1.87,2.33-1.53.94-5.48a6.42,6.42,0,0,0,.84-6.58,7.12,7.12,0,0,0-.12-6.64s3-6.5-1.46-9.89C731.22,1352.92,730.27,1353,729.63,1353.15Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M704,1355.81s10,3.21,14.68,7.64c1.06,1,1.91,2.2,1.41,3.7s-3.06,2.72-7.48,1.58-10.69-.37-10.69-.37S697.75,1365.71,704,1355.81Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M716.83,1695.86s-9.36-58.41-9.86-60.78-10-10.88-55.54-25.79c0,0,50.6,9.84,63.87,18.48C725.53,1634.42,716.83,1695.86,716.83,1695.86Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M907.36,1513.05c5-2.08,13.06-25.68,16.95-37.9,1.38-4.33,2.23-7.23,2.23-7.23h-45.7c3.95,28.2,13.54,45.13,13.54,45.13Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M911,1453.86c0-1.64,7.34-8.51,11-13s-1.41-13-1.41-13c-16.37,6.77-13.54,26-13.54,26S911,1455.5,911,1453.86Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M901.72,1454.59h2s1.41-33.22-10.72-37.73-12.13-13.54-12.13-13.54-3.67,12.41,2.26,18.9,12.69,14.1,11.56,20.31S901.72,1454.59,901.72,1454.59Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M924.31,1475.15c1.38-4.33,2.23-7.23,2.23-7.23h-45.7c3.95,28.2,13.54,45.13,13.54,45.13h3C896.81,1486.64,914.2,1478,924.31,1475.15Z",
    transform: "translate(-342.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "583.8 1453.86 537.77 1453.86 535.15 1467.92 585.67 1467.92 583.8 1453.86"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskBanner);
export default __webpack_public_path__ + "static/media/task-banner.7e495b96a37c42dc3c167c3576d9ca82.svg";
export { ForwardRef as ReactComponent };